import React from 'react';
import { ChefHat, ChevronRight } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * MealsCardWidget - Get recipe ideas based on pantry
 */
export default function MealsCardWidget({ 
  stockedItems = [],
  onNavigate 
}) {
  const hasIngredients = stockedItems.length > 0;

  return (
    <button
      onClick={() => onNavigate && onNavigate('meals')}
      style={{
        width: '100%',
        padding: '20px',
        background: ABLE_COLORS.neutral,
        border: 'none',
        borderRadius: ABLE_COLORS.cardRadius,
        boxShadow: ABLE_COLORS.cardShadow,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        transition: 'all 0.15s ease',
        textAlign: 'left',
      }}
    >
      {/* Icon */}
      <div style={{
        width: '40px',
        height: '40px',
        borderRadius: '10px',
        background: '#FCE7F3',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}>
        <ChefHat size={20} color="#DB2777" />
      </div>
      
      {/* Content */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{
          fontSize: '16px',
          fontWeight: 700,
          color: ABLE_COLORS.textPrimary,
          marginBottom: '4px',
        }}>
          Meal Ideas
        </div>
        <div style={{
          fontSize: '13px',
          fontWeight: 400,
          color: hasIngredients ? ABLE_COLORS.textSecondary : ABLE_COLORS.textMuted,
        }}>
          {hasIngredients ? "Based on what you have" : "Add ingredients first"}
        </div>
      </div>
      
      {/* Arrow */}
      <ChevronRight size={18} color={ABLE_COLORS.textMuted} style={{ flexShrink: 0 }} />
    </button>
  );
}
